import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { NetworkStatusItem } from '../models/NetworkStatus';
import config from '../config';
const log = getLogger('simManagement.api.networkStatusApi');

export function getByCompanyId(id: number): Promise<NetworkStatusItem[]> {
  const url = config.API_BASE_URL + `api/company/${id}/networkstatus`;
  return new Promise<NetworkStatusItem[]>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data as NetworkStatusItem[];
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error(`Failed to load alerts for company ${id}.`, simManagementError);
        reject(simManagementError);
      });
  });
}

export function getByCompanyIdAndAccountId(companyId: number, accountId: number): Promise<NetworkStatusItem[]> {
  const url = config.API_BASE_URL + `api/company/${companyId}/account/${accountId}/networkstatus`;
  return new Promise<NetworkStatusItem[]>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data as NetworkStatusItem[];
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error(`Failed to load alerts for company ${companyId}.`, simManagementError);
        reject(simManagementError);
      });
  });
}
